<template>
  <a-modal
    class="modal-preview"
    :open="open"
    width="576px"
    :mask-closable="false"
    @cancel="handleClose"
    :footer="false"
    title="Previsualizar plan"
    centered
  >
    <CustomScrollbar
      :height="
        !isCustomerConfig ?
          'calc(100vh - 200px)' :
          fullPrice ?
            'calc(100vh - 338px)' :
            'calc(100vh - 235px)'
      "
      class="scrollbar"
    >
      <img :src="urlImage(planTypeIcon(plan.plan))" alt="plan" style="height: 56px" />
      <h2 style="margin-bottom: 0">{{ PlanTypeText[plan.plan as PlanType] }}</h2>
      <div v-if="configuration" class="price">
        <span class="price_slot">
          ${{ configuration.price_per_slot.value || configuration.price_per_slot_base.value }} 
        </span>
        <span class="price_description">
          por slot/mes
        </span>
        <!-- <p class="price_info" v-if="!isCustomerConfig">
          <InfoCircleOutlined />
          Precio de alta no incluido
        </p> -->
        <p class="price_info" v-if="configuration.aditional_charge">
          <InfoCircleOutlined />
          IGV no incluido
        </p>
        <!-- <p class="price_type" v-if="isCustomerConfig">
          <a-tag v-if="plan.type_plan_license" :color="PlanPayTypeColor[plan.type_plan_license]">
            {{ PlanPayTypeText[plan.type_plan_license] }}
          </a-tag>
          <a-tag>Personalizado</a-tag>
        </p> -->
      </div>
      <a-divider class="divider" />
      <div v-if="configuration">
        <!-- <div v-if="isCustomerConfig" class="section" style="margin-top: 15px">
          <h3>Pago del plan</h3>
          <a-card class="section_item">
            <p class="section_item--value">
              {{ PlanPayTypeText[plan.type_plan_license] }}
            </p>
            <p class="section_item--text">
              {{ PlanPayTypeDescription[plan.type_plan_license] }}
            </p>
          </a-card>
        </div>
        <div v-if="isCustomerConfig" class="section">
          <h3>Pago de consumo</h3>
          <a-card class="section_item">
            <p class="section_item--value">
              {{ PlanPayTypeText[plan.type_plan_consume] }}
            </p>
            <p class="section_item--text">
              {{ ConsumePayTypeDescription[plan.type_plan_consume] }}
            </p>
          </a-card>
        </div>
        <div v-if="isCustomerConfig" class="section">
          <h3>Impuestos</h3>
          <a-card class="section_item">
            <p class="section_item--value">
              País: Perú
            </p>
            <p class="section_item--text">
              Se sumará un 18% al pago mensual del plan.
            </p>
          </a-card>
        </div> -->
        <div class="section" style="margin-top: 40px">
          <h3>Precio de slots y alta</h3>
          <SectionItemPlan 
            title="Slots mensuales"
            tooltip="Cantidad de slots disponibles para el plan."
            :messageValue="`${configuration.slots_per_month?.value} slots`"
            :messageInfo="!isCustomerConfig ? `${configuration.slots_per_month.customizable ? 'Personalizable' : 'No personalizable'}` : ''"
          />
          <SectionItemPlan 
            title="Precio por slot"
            tooltip="El precio por slot puede incluir costos adicionales por la suma de configuraciones extras."
            :messageValue="`$${configuration.price_per_slot_base?.value}`"
            :messageInfo="!isCustomerConfig ? `${configuration.price_per_slot_base.customizable ? 'Personalizable' : 'No personalizable'}` : ''"
          />
          <SectionItemPlan 
            title="Precio de alta"
            tooltip="Pago único que se cobrará al cliente al registrarse. De ser $0, se omitirá el cobro."
            :messageValue="`$${configuration.high_price?.value}`"
            :messageInfo="!isCustomerConfig ? `${configuration.high_price.customizable ? 'Personalizable' : 'No personalizable'}` : ''"
          />
        </div>
        <div class="section">
          <h3>Canales disponibles</h3>
          <a-card class="section_item" v-if="Object.keys(filteredChannelsMessagingMail).length > 0">
            <p style="margin-bottom: 10px">Mensajería y correo</p>
            <div class="channels">
              <div 
                v-for="(icon, type) in filteredChannelsMessagingMail" 
                :key="type"
                class="channels_item"
              >
                <SocialIcon 
                  :type="icon" 
                  width="20" 
                />
                <span class="channels_item--text">
                  {{ ChannelTypeText[type] }}
                </span>
              </div>
            </div>
          </a-card>
          <a-card
            class="section_item"
            v-if="Object.keys(filteredChannelsSocialMedia).length > 0"
          >
            <p style="margin-bottom: 10px">Redes sociales</p>
            <div class="channels">
              <div 
                v-for="(icon, type) in filteredChannelsSocialMedia" 
                :key="type"
                class="channels_item"
              >
                <SocialIcon 
                  :type="icon" 
                  width="20" 
                />
                <span class="channels_item--text">
                  {{ ChannelTypeText[type] }}
                </span>
              </div>
            </div>
          </a-card>
          <a-card
            class="section_item"
            v-if="Object.keys(filteredChannelsVoiceMedia).length > 0"
          >
            <p style="margin-bottom: 10px">Telefonía</p>
            <div class="channels">
              <div 
                v-for="(icon, type) in filteredChannelsVoiceMedia" 
                :key="type"
                class="channels_item"
              >
                <SocialIcon 
                  :type="icon" 
                  width="20" 
                />
                <span class="channels_item--text">
                  {{ ChannelTypeText[type] }}
                </span>
              </div>
            </div>
          </a-card>
        </div>
        <div class="section">
          <h3>Cantidades</h3>
          <SectionItemPlan 
            v-if="configuration.creating_forms?.value > 0 && ![PlanType.AllInOne, PlanType.DigitalVoice].includes(plan?.plan)"
            title="Creación de formularios"
            tooltip="Cantidad de formularios disponibles para el plan."
            :messageValue="
              configuration.creating_forms?.unlimited
                ? 'Ilimitado' :
                `${configuration.creating_forms?.value} formularios`
            "
            :messageInfo="!isCustomerConfig ? configuration.creating_forms.info : ''"
          />
          <SectionItemPlan
            v-if="configuration.email_accounts?.value > 0 && plan?.plan != PlanType.AllInOne"
            title="Cuenta de correo (buzones)"
            tooltip="Cantidad de cuentas de correo disponibles para el plan"
            :messageValue="
              configuration.email_accounts?.unlimited
                ? 'Ilimitado' :
                `${configuration.email_accounts?.value} buzones`
            "
            :messageInfo="!isCustomerConfig ? configuration.email_accounts.info : ''"
          />
          <SectionItemPlan 
            title="Contactos como máximo por estrategia"
            tooltip="Cantidad de contactos disponibles por estrategia para el plan."
            :messageValue="`${configuration.max_contacts_strategy?.value} contactos`"
            :messageInfo="!isCustomerConfig ? `${configuration.max_contacts_strategy.customizable ?  'Personalizable' : 'No personalizable' }` : ''"
          />
          <SectionItemPlan 
            title="Estrategias como máximo concurrentes"
            tooltip="Cantidad de estrategias concurrentes disponibles."
            :messageValue="`${configuration.max_concurrent_strategy?.value} estrategias`"
            :messageInfo="!isCustomerConfig ? `${configuration.max_concurrent_strategy?.next_value} estrategias +$5 por slot` : ''"
          />
        </div>
        <div class="section" v-if="configuration.channels.voz && plan?.plan != PlanType.AllInOne">
          <h3>Telefonía</h3>
          <SectionItemPlan 
            title="IVR saliente"
            tooltip="Indica si las estrategias del tipo IVR está incluido o no en el plan."
            :messageValue="`${configuration.ivr_outbound?.active ? 'Activado' : 'Desactivado'}`"
            :messageInfo="!isCustomerConfig ? configuration.ivr_outbound?.info : ''"
          />
          <SectionItemPlan 
            title="Marcación telefónica predictiva"
            tooltip="Indica si las estrategias del tipo Predictivo está incluido o no en el plan."
            :messageValue="`${configuration.dial_predictive?.active ? 'Activado' : 'Desactivado'}`"
            :messageInfo="!isCustomerConfig ? configuration.dial_predictive?.info : ''"
          />
        </div>
        <!-- <div class="section">
          <h3>Funcionalidades</h3>
          <a-card class="section_item">
            <p class="section_item--text">
              <span>
                Monitoreo en tiempo real remoto
                <InfoCircleOutlined />
              </span>
              <span>
                {{ configuration.real_time_monitoring ? 'Activado' : 'Desactivado' }}
              </span>
            </p>
          </a-card>
          <a-card class="section_item">
            <p class="section_item--text">
              <span>
                Secuencias (Workflows)
                <InfoCircleOutlined />
              </span>
              <span>
                {{ configuration.workflows_enabled ? 'Activado' : 'Desactivado' }}
              </span>
            </p>
          </a-card>
        </div> -->
        <div class="section">
          <h3>Beex API</h3>
          <SectionItemPlan 
            title="Consumo de Beex API"
            tooltip="Indica si el consumo de Beex API está incluido o no en el plan."
            :messageValue="`${configuration.beex_api?.active ? 'Activado' : 'Desactivado'}`"
            :messageInfo="!isCustomerConfig && plan?.plan != PlanType.AllInOne ? configuration.beex_api.info : ''"
          />
        </div>
        <div class="section" v-if="plan?.plan == PlanType.AllInOne">
          <h3>Nueva exposición de APIs v2 y MCP</h3>
          <SectionItemPlan 
            title="Token de acceso a APIs v2 y MCP"
            tooltip="Permite generar un token de acceso para consumir las nuevas APIs de lectura (v2) y conectar el MCP de BeexCC con otras aplicaciones. Solo puede existir un token activo a la vez."
            :messageValue="`${configuration.api_cloud_token?.active ? 'Activado' : 'Desactivado'}`"
            :messageInfo="!isCustomerConfig ? apiCloudDetailText : ''"
          />
        </div>
        <div class="section" v-if="plan?.plan == PlanType.AllInOne">
          <h3 style="display: flex; align-items: center; gap: 7px">
            <img :src="urlImage('ai-icon.svg')" alt="beex-ai"/>
            Beex AI
          </h3>
          <SectionItemPlan 
            title="Resúmenes de tickets de chat"
            tooltip="Indica si el uso de Beex AI está incluido o no en el plan."
            messageValue="Activado"
          >
            <template #aditional>
              <a-tag color="geekblue">
                Exclusivo para este plan
              </a-tag>
            </template>
          </SectionItemPlan>
        </div>
        <div class="section" v-if="plan?.plan == PlanType.AllInOne">
          <h3>
            Workflows (Secuencias)
          </h3>
          <SectionItemPlan 
            title="Módulo de Secuencias"
            tooltip="Indica si el módulo de Secuencias está incluido o no en el plan."
            messageValue="Activado"
          >
            <template #aditional>
              <a-tag color="geekblue">
                Exclusivo para este plan
              </a-tag>
            </template>
          </SectionItemPlan>
        </div>
        <div class="section">
          <h3>Almacenamiento y rango de búsqueda</h3>
          <h4>Grabaciones</h4>
          <div class="section__double">
            <SectionItemPlan 
              title="Tiempo de almacenamiento"
              tooltip="Tiempo en el que se almacenarán todas las grabaciones."
              :messageValue="`${configuration.recordings_time?.value} meses`"
            />
            <SectionItemPlan 
              title="Rango de búsqueda"
              tooltip="Encuentra todas las grabaciones registradas dentro del rango de búsqueda."
              :messageValue="`${configuration.recordings_search_range?.value} meses de rango`"
            />
          </div>
          <h4>Mensajería y datos</h4>
          <div class="section__double">
            <SectionItemPlan 
              title="Tiempo de almacenamiento"
              tooltip="Tiempo en el que se almacenarán todos los mensajes y datos."
              :messageValue="`${configuration.messaging_time?.value} meses`"
            />
            <SectionItemPlan 
              title="Rango de búsqueda"
              tooltip="Encuentra todos los mensajes y datos registrados dentro del rango de búsqueda."
              :messageValue="`${configuration.messaging_search_range?.value} meses de rango`"
            />
          </div>
        </div>
        <div class="section">
          <h3>Contrato</h3>
          <SectionItemPlan 
            title="Tiempo a contratar"
            tooltip="Tiempo de duración del contrato."
            :messageValue="`${configuration.min_contract_time?.value} meses`"
            :messageInfo="configuration.min_contract_time?.info"
          />
        </div>
        <div class="section">
          <h3>Incluye y no incluye todo lo siguiente:</h3>
          <div v-for="item in configuration.description">
            <h4>{{ item.title }}</h4>
            <ul class="section_include">
              <li v-for="subitem in itemsIncludes(item.items)">
                <img :src="urlImage('check-circle-icon.svg')" alt="Icono" class="icon" />
                {{ subitem.text }}
              </li>
            </ul>
            <ul class="section_not_include">
              <li v-for="subitem in itemsNotIncludes(item.items)">
                <img :src="urlImage('close-circle-icon.svg')" alt="Icono" class="icon" />
                {{ subitem.text }}
              </li>
            </ul>
          </div>
          <!-- <h3>Incluye también todo lo siguiente:</h3>
          <div v-for="item in configuration.include">
            <h4>{{ item.title }}</h4>
            <ul class="section_include">
              <li v-for="subitem in item.items">
                <img :src="urlImage('check-circle-icon.svg')" alt="Icono" class="icon" />
                {{ subitem }}
              </li>
            </ul>
          </div>
          <h3>No incluye lo siguiente:</h3>
          <div v-for="item in configuration.include">
            <h4>{{ item.title }}</h4>
            <ul class="section_not_include">
              <li v-for="subitem in item.items">
                <img :src="urlImage('close-circle-icon.svg')" alt="Icono" class="icon" />
                {{ subitem }}
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </CustomScrollbar>
    <!-- <a-divider v-if="isCustomerConfig" class="divider divider-bottom" /> -->
    <!-- <SectionTotalPriceDetails
      class="section-total"
      v-if="isCustomerConfig && configuration"
      :plan="plan"
      v-model:full="fullPrice"
    /> -->
  </a-modal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { 
  InfoCircleOutlined,
} from "@ant-design/icons-vue";
import {
  ChannelType,
  ChannelTypeAttribute,
  PlanPayTypeText,
  PlanPayTypeColor,
  PlanPayTypeDescription,
  ConsumePayTypeDescription,
  PlanType,
  PlanTypeText,
} from "@/app/common/types";
import {
  ChannelTypeIcon,
  ChannelTypeText,
  PlanTypeIcon,
} from "@/app/common/utils/texts";
import SocialIcon from "@/app/common/components/icons/SocialIcon.vue";
import SectionItemPlan from "@/app/common/components/plan-config/sections/SectionItemPlan.vue";
import SectionTotalPriceDetails from "../cards/SectionTotalPriceDetails.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
    required: true,
  },
  plan: {
    type: Object,
    required: true,
  },
  isCustomerConfig: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const channelMessagingMail = [
  ChannelType.WhatsApp,
  ChannelType.Webchat,
  ChannelType.Email,
  ChannelType.Sms,
];

const channelSocialMedia = [
  ChannelType.Messenger,
  ChannelType.Instagram,
];

const channelVoiceMedia = [
  ChannelType.Telefonia,
];

const fullPrice = ref(false);
const configuration = computed(() => 
  Object.keys(props.plan.configuration).length == 0 ? null : props.plan.configuration
);

// Mismo detalle que en la vista de detalles del plan (franquicia, excedente y precio por slot).
const apiCloudDetailText = computed(() =>
  [
    configuration.value?.api_cloud_calls?.value != null
      ? `Incluye ${Number(configuration.value.api_cloud_calls.value).toLocaleString("en-US")} API calls gratuitas por mes`
      : null,
    configuration.value?.api_cloud_calls?.overage_price != null
      ? `$${configuration.value.api_cloud_calls.overage_price} por call adicional`
      : null,
    configuration.value?.api_cloud_token?.price != null
      ? `+$${configuration.value.api_cloud_token.price} por slot`
      : null,
  ]
    .filter(Boolean)
    .join(" · ")
);

const planTypeIcon = (id: number) => {
  return PlanTypeIcon[id as keyof typeof PlanTypeIcon];
};

const filteredChannels = (channels: any, filters: ChannelType[]) => {
  const filteredIcons = Object.entries(ChannelTypeIcon)
    .filter(([key]) => filters.includes(key as ChannelType));

  return filteredIcons.reduce((acc, [type, icon]) => {
    const attribute = ChannelTypeAttribute[type as ChannelType];
    if (channels[attribute]) {
      acc[type as ChannelType] = icon;
    }
    return acc;
  }, {} as Record<ChannelType, string>);
};

const filteredChannelsMessagingMail = computed(() => {
  return filteredChannels(props.plan.configuration.channels, channelMessagingMail) || [];
});

const filteredChannelsSocialMedia = computed(() => {
  return filteredChannels(props.plan.configuration.channels, channelSocialMedia) || [];
});

const filteredChannelsVoiceMedia = computed(() => {
  return filteredChannels(props.plan.configuration.channels, channelVoiceMedia) || [];
});

const emit = defineEmits(["update:open"]);

const urlImage = (image: any) => {
  return new URL(`../../../common/assets/${image}`, import.meta.url).href;
};

const itemsIncludes = (items: any[]) => {
  return items?.filter(el => el.value);
}

const itemsNotIncludes = (items: any[]) => {
  return items?.filter(el => el.value == false);
}

const handleClose = () => {
  emit("update:open", false);
};
</script>

<style lang="sass" scoped>
.modal-preview
  .plan-card
    border: 1px solid #00000026
  .section_price
    &__details
      padding: 0 24px

:global(.modal-preview .ant-modal-content)
  padding: 20px 0 !important
:global(.modal-preview .ant-modal-title)
  padding: 0 24px !important
.section
  margin-top: 25px
  h4
    margin: 10px 0
  &__double
    display: grid
    grid-template-columns: 1fr 1fr
    gap: 10px
  &_item
    border: 1px solid #00000026
    margin-top: 8px
    :deep(.ant-card-body)
      padding: 10px 15px !important
      // background-color: #00000005
    &--content
      width: 100%
      display: flex
      justify-content: space-between
      align-items: center
    &--value
      font-weight: 600
    &--text
      display: flex
      align-items: center
      justify-content: space-between
      .anticon
        margin-left: 5px
    &--info
      color: $gray-7
  &_include
    margin-bottom: 0
  &_include, &_not_include
    list-style: none
    padding-left: 0
    li
      display: flex
      align-items: top
      margin-bottom: 5px
    .icon
      width: 16px
      height: 16px
      margin-right: 8px
      margin-top: 3.7px

.price
  margin-bottom: 6px
  &_slot
    font-size: 22px
    font-weight: 600
  &_description
    font-size: 14px
    color: $gray-8
  &_info
    color: $gray-8
    font-style: italic
  &_type
    margin-top: 10px
.divider
  position: absolute
  left: 0
  margin: 10px 0
  margin-bottom: 30px

.divider-bottom
  margin: 0
  filter: drop-shadow(0 -5px 5px rgba(0, 0, 0, 0.2))

.scrollbar
  padding: 0 24px
  // padding-right: 8px
  padding-top: 10px !important

.channels
  display: flex
  // margin-bottom: 10px
  gap: 20px
  &_item
    break-inside: avoid
    display: flex
    align-items: center
    gap: 5px
    margin-bottom: 5px
    .anticon
      height: 20px

.section_price
  &__details
    margin-top: 10px
</style>